import React from 'react';
import './index.less';

const ContainerCard = ({ className, children }) => {
  return <div className={`${className} containerCard `}>{children}</div>;
};

export default ContainerCard;
